module.exports = __webpack_public_path__ + "img/purpose-1.6e3c8071.svg";